import { Component, input, ChangeDetectionStrategy } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';

import { CoreMenuItem } from 'app/back-office/shared/models/core';
import { FeatherIconDirective } from 'app/back-office/shared/directives/feather-icon/feather-icon.directive';

@Component({
    selector: '[core-menu-vertical-section]',
    imports: [TranslateModule, FeatherIconDirective],
    changeDetection: ChangeDetectionStrategy.Eager,
    templateUrl: './section.component.html'
})
export class CoreMenuVerticalSectionComponent {
  item = input.required<CoreMenuItem>();
}
